import { TunaDivider } from '../primitives/divider.js'
import type { TunaDividerProps } from '../primitives/divider.js'
import type { FC } from 'react'

export const Divider: FC<TunaDividerProps> = ({ style, ...props }) => (
  <TunaDivider
    {...props}
    style={{
      marginTop: 8,
      marginBottom: 8,
      fontSize: 'var(--tuna-typography-caption-fontSize)',
      color: 'var(--tuna-palette-text-secondary)',
      textTransform: 'uppercase',
      ...style,
    }}
  />
)
